<template>
  <div class="text-center">
    <h2>Registration Success!</h2>
    <p>We'll get back to you soon. Check your email later.</p>
    <v-btn @click="redirect()">Check our Facebook Page</v-btn>
  </div>
</template>

<script>
export default {
  name: 'RegisterSuccess',
  methods: {
    redirect() {
      window.location.href = 'https://www.facebook.com/KorPhilDavao';
    }
  }
}
</script>